import CommentsLive from '../../service/comments';
import Config from '../../config';
import Module from '../../core/module';
import Tasks from '../../collection/tasks';
import TaskFilter from '../../view/tasks.filter';

import { TaskNew, newTask } from '../../view/task.new';
import { Insert } from '../../service/live';
import { fetch } from '../../collection/comments';
import { ask, } from '../../utils/popups';
import { del } from '../../http/api';
import { promisify, } from '../../utils/promisify';
import { beginLock, endLock } from '../../loader';





const     
    OPEN_TASK = 'tasks-form-open',
    OPEN_LIST = 'tasks-list-open',
    OPEN_MAP = 'tasks-map-open',
    OPEN_CONTRACTS = 'contracts-list-open';

export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        const opts = () => {
            const { 
                layers, datatables, clusters,
                types, organizations, contracts,
                statuses, priorities, fields, roles,
                serviceObjectMappings,
                locationService
            } = options;

            return { 
                layers, datatables, clusters,
                locationService,
                types, organizations, contracts,
                statuses, priorities,
                fields,
                roles,
                serviceObjectMappings, 
            };
        };

        const actions = this.options.actions = {
            
            defaults: 'edit',
        
            multitask: () =>
                promisify( newTask( new TaskNew( opts() ), opts().priorities ) )
                    .then( () => beginLock( this ) )
                    .then( () => issues.fetch() )
                    .then( () => endLock( this ) ),
            
            edit: (current) =>
                this.trigger( OPEN_TASK, current ),
            
            destroy: {
        
                disabled: (current) => 
                    !current || !current.capabilities_.delete,

                handler: (current) =>
                    ask( 'issue::modal delete - confirmation text', undefined, 'actions::yes', 'actions::no',
                        () => del( `/tasks/${current.id}` ).blocking( this ).cerebellum().execute() )
                        .then( () => {
                            // deleting last task on the page?
                            if (issues.total == (this.state().page - 1) * 7 + 1)
                                // triggering page will force page change + reload + hash change
                                this.trigger( 'Paging:page', this.state().page - 1 );
                            else
                                beginLock( this ), issues.fetch().finally( () => endLock( this ) ); 
                        } ),
            }

        };
        
        const issues = this.options.issues = new Tasks( [], { actions: actions, } );

        this.setState( {
            filters: TaskFilter.defaultFilters(),
        } );

        this.commentsChannel = CommentsLive
            .filter( message => message instanceof Insert )
            .forEach( message => this.trigger( 'comments:income', message.model ) ); // model === attrs of Model
    },

    template: 'jst/module.tasks.list',

    url() {
        return 'tasks';
    },

    open() {
        const { issues } = this.options;

        const httpFilters = Tasks.getHttpFilters( this.state() );
        const { page, filters, activeId, } = this.state();
        
        return promisify( issues.filter( httpFilters, page, activeId ) )
            .then( () => this.render() )
            .then( () => {
                const filter = this.Filter.bind( new TaskFilter.Model( filters ) );
                const current = issues.current();
                if (!current)
                    return filter;

                return this.setState( { activeId: current.id } ),
                    Promise.all( [filter, this.Map.bind( current )] );
             } )
            .then( () => this );
    },

    start() {
        const { issues } = this.options;
        let lastFiltering = Promise.resolve();

        issues.plugActionSource( this.Grid );

        // this.listenTo( this.Search, 'search', queryString => 
        //     lastFiltering = lastFiltering
        //         .then( () => {
        //             this.setState( { queryString, } );
        //             this.navigated();
        //             return issues.filter( getHttpFilters( this.state() ) );
        //         } )
        //         .catch( () => undefined ) );

        if (issues.current())
            this.Comments.bind( issues.current() );

        this.Map.listenTo( issues, 'activate deactivate', 
            () => {
                const current = issues.current();
                const activeId = current ? current.id : undefined;
                if (this.state().activeId == activeId)
                    return;

                this.setState( { activeId, } );
                this.navigated();

                if (current && !current.comments_)
                    fetch( current.id ).then( ([json, coll]) =>
                        current.trigger( 'comments:load', current.comments_ = json ) );

                this.Map.bind( issues.current() );
                this.Comments.bind( issues.current() );
            } );

        this.listenTo( this, 'comments:income',
            comment => handleIncomingComment.call( this, comment ) );

        this.Filter.focus();
    },

    stop() {
        const { issues } = this.options;

        issues.unplugActionSource( this.Grid );
        this.Grid.ungrab( issues );
        this.Paging.ungrab( issues );

        this.stopListening( this.Paging );
        this.stopListening( this.Filter );
        this.stopListening( this, 'comments:income' );

        this.Map.stopListening( issues );

        return this;
    },

    serialize() {
        const { issues, locationService, } = this.options;

        return {
            queryString: this.state().queryString || '',
            actionList: issues.actions,
            collection: issues,
            locationService,
        };
    },

    events: {

        'keyup [name=title]'(e) {
            if (13 == e.keyCode)
                this.Grid.trigger( 'action:default' ),
                e.preventDefault();
        },

        'keydown [name=title]'(e) {
            switch (e.keyCode) {
                case 38: 
                    this.options.issues.prevRow();
                    break;
                case 40: 
                    this.options.issues.nextRow();
                    break;
            }
        },

    },

    [Module.event( 'Paging:page' )](page) {
        this.setState( { page, } );
        this.navigated();
        beginLock( this );
        this.options.issues.setPage( page )
            .then( () => endLock( this ) );
    },

    [Module.event( 'Filter:filter' )](filters) {
        this.setState( { filters, } );
        this.navigated();
        this.Grid.afterRendering().then( () => 
            this.options.issues.filter( Tasks.getHttpFilters( this.state() ) ) ); 
    },

    [Module.event( 'Comments:comments:recalc-unread' )]() {
        this.Grid.render();
    },

    [Module.event( 'nav:map' )]() {
        this.trigger( OPEN_MAP, this.state() );
    },

    [Module.event( 'nav:contracts' )]() {
        this.trigger( OPEN_CONTRACTS, this.state() );
    },

}, {

    OPEN_TASK,

    OPEN_LIST,

    OPEN_MAP,

    OPEN_CONTRACTS,

} );

function handleIncomingComment(commentJson) {
    const { issues: tasks } = this.options;
    
    const taskId = +commentJson.task_id || +commentJson.news_id;
    const task = tasks.find( m => m.id === taskId );
    if (!task)
        return;

    task.set( 'lastComment', commentJson );
    if (task.comments_ && task.comments_ instanceof Array)
        task.comments_.unshift( commentJson );

    if (commentJson.user_id == Config.userId())
        return task.set( 'unread_message_count', 0 ), this.Grid.render();

    const unread = task.get( 'unread_message_count' );
    if (unread === null)
        return this.Grid.render();

    task.set( 'unread_message_count', unread + 1 ),
    task.trigger( 'comments:unread-incoming' );

    this.Grid.render();
}


// WEBPACK FOOTER //
// ./src/js/module/tasks/list.js